__turbopack_context__.v({
  "accountSection": "_4g7Q3G_accountSection",
  "algSearch": "_4g7Q3G_algSearch",
  "header-button-container": "_4g7Q3G_header-button-container",
  "header-right": "_4g7Q3G_header-right",
  "invisible": "_4g7Q3G_invisible",
  "logo": "_4g7Q3G_logo",
  "logoCentered": "_4g7Q3G_logoCentered",
  "logoHideMenu": "_4g7Q3G_logoHideMenu",
  "logoutButton": "_4g7Q3G_logoutButton",
  "menu": "_4g7Q3G_menu",
  "menuCenterLogo": "_4g7Q3G_menuCenterLogo",
  "menuJustifyContent": "_4g7Q3G_menuJustifyContent",
  "new-header": "_4g7Q3G_new-header",
  "new-header-margin-bottom": "_4g7Q3G_new-header-margin-bottom",
  "offcanvasAccountIcon": "_4g7Q3G_offcanvasAccountIcon",
  "offcanvasAccountLink": "_4g7Q3G_offcanvasAccountLink",
  "searchBarRow": "_4g7Q3G_searchBarRow",
  "searchIcon": "_4g7Q3G_searchIcon",
  "searchIconColor": "_4g7Q3G_searchIconColor",
  "signin": "_4g7Q3G_signin",
  "subscribe": "_4g7Q3G_subscribe",
  "tablet-account": "_4g7Q3G_tablet-account",
  "visible": "_4g7Q3G_visible",
});
